import { useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_E_RETAIL_BUYERS_DETAILS } from "../../routes";

export default function useViewMappingDetails() {
  const [isLoading, setIsLoading] = useState(false);
  const [mappingDetails, setMappingDetails] = useState([]);

  const getMappingDetails = (buyerIds) => {
    setIsLoading(true);
    setMappingDetails([]);
    return Api.post(API_ROUTE_E_RETAIL_BUYERS_DETAILS, { buyerIds })
      .then((response) => {
        setMappingDetails(response.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    isLoading,
    mappingDetails,
    getMappingDetails,
  };
}
